import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { styled } from "@mui/material/styles";
import { Button, Container, Grid, Typography } from "@mui/material";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import HeaderInternal from "./Header/HeaderInternal";
import { AccountContext } from "../store/AccountContext";
import InstallApp from "./common/InstallApp/InstallApp";
import TvAppPromo from "./common/TvAppPromo";
import { v4GridContainerWidthSx } from "../theme/v4CompatSx";

import Seo from "./common/Seo";

// Styles
const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.background.ffNavy,
  },
}));

/*
 * #1088: /app leads with the shared "Install The Free App" hero. #1264: its
 * links, and the footer's, go straight to the stores (they went through
 * smart.link, which sent phones to the sign-up page). Below the hero, the TV
 * promo and the "Prefer the website?" fallback are moved here unchanged from the old
 * `Banners/SuccessAppTrial.js` (its `background`, `playerWrapper`,
 * `smartDeviceContainer`, `smartDeviceText` and `secondaryTrialButton` rules),
 * converted to MUI v5+ per docs/mui-conversion-guide.md. Dropped as inert:
 * the Container's `fixedcomponent="main"` (a misspelt prop forwarded to the
 * DOM) and the Grid item's `display="flex"` (the same; `playerWrapper` set
 * `display: flex` itself).
 */

// was: SuccessAppTrial.js useStyles().background — a bare <div>.
const PromoBackground = styled("div")(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.ffNavy,
  padding: theme.spacing(4, 0),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(6, 0),
  },
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(8, 0),
  },
}));

// was: useStyles().playerWrapper
const playerWrapperSx = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

// was: useStyles().smartDeviceContainer. The width restores v4's unconditional
// `.MuiGrid-container { width: 100% }` (guide §2): this container sits inside
// the flex-column `playerWrapper` item.
const smartDeviceContainerSx = {
  ...v4GridContainerWidthSx,
  textAlign: "center",
};

// was: useStyles().smartDeviceText — body2 has no breakpoint rules, so the flat
// values port as they are. The text colour is body2's theme colour, as before.
const smartDeviceTextSx = (theme) => ({
  fontSize: "0.8rem",
  marginTop: "16px",
  marginBottom: "8px",
  "& a": {
    color: theme.palette.background.ffGreen,
  },
});

// was: useStyles().secondaryTrialButton
const secondaryTrialButtonSx = (theme) => ({
  borderWidth: "1px",
  borderColor: theme.palette.common.white,
  color: theme.palette.common.white,
  width: "90%",
  fontSize: "0.8rem",
  padding: "8px",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
    padding: "8px 24px",
  },
  "&:hover": {
    backgroundColor: "transparent",
    color: "#eee",
    transform: "none",
    border: "1px solid #eee",
  },
});

const FarmFLiXApp = (props) => {
  const classes = useStyles();

  const { loggedIn } = useContext(AccountContext);

  return (
    <div className={classes.container}>
      <Seo
        title="The FarmFLiX App is here"
        description="Get the FarmFLiX App Now, available on the App Store and Google Play Store.  Download Now for Free."
        path="/app"
      />
      <>
        {loggedIn && <HeaderInternal />}
        {!loggedIn && <Header />}
      </>
      <InstallApp
        layout="hero"
        links="store"
        subline="Watch Anytime. Watch Anywhere."
      />
      <PromoBackground>
        <Container fixed maxWidth="md">
          <Grid container>
            <Grid size={{ xs: 12, sm: 12, md: 12 }} sx={playerWrapperSx}>
              <div style={{ width: "100%", margin: "32px 0 8px" }}>
                <TvAppPromo />
              </div>
              <Grid container sx={smartDeviceContainerSx}>
                <Grid size={12}>
                  <Typography variant="body2" sx={smartDeviceTextSx}>
                    <b>Prefer the website? No Problem</b>
                  </Typography>
                  <a
                    href={"/trybuy"}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <Button
                      size="small"
                      variant="outlined"
                      sx={secondaryTrialButtonSx}
                    >
                      Click Here
                    </Button>
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </PromoBackground>
      <Footer />
    </div>
  );
};

export default FarmFLiXApp;
